export const en = {
    availability: {
        comingSoon: "Slideshow coming soon...",
        unavailable: "Slideshow unavailable.",
        unavailableMessage: "This slideshow is no longer publicly viewable."
    },
    controls: {
        toggleMediaDescription: "Toggle viewing the media description"
    },
    notFound: {
        message: "Slideshow URLs are of the form {{homeRoute}}/[:user id]/[:token]",
        title: "Slideshow Not Found"
    }
};
